// extracted by mini-css-extract-plugin
export default {"page":"Classrooms_page__bTSNO","container":"Classrooms_container__4kmBI","header":"Classrooms_header__dVQmC","bar":"Classrooms_bar__ZAcOE","table":"Classrooms_table__669Ze"};